import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
TextField,
Alert,
CircularProgress
} from "@mui/material";

import { Colors } from "../utils/colors";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "../constant/apiConstant";

const VerifyOTP = () => {

const navigate = useNavigate()
const location = useLocation()

const email = location.state?.email || ""

const [otp,setOtp] = useState("")
const [loading,setLoading] = useState(false)

const [alert,setAlert] = useState({
show:false,
type:"info",
message:""
})

const showAlert=(type,message,time=5000)=>{

setAlert({
show:true,
type,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,show:false}))
},time)

}




const verifyOTP = async () => {

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/otp/forgot-password/verify-otp`,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
email,
otp
})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Invalid OTP")
setLoading(false)
return

}

showAlert("success","OTP verified successfully")

setTimeout(()=>{
const resetToken = String(data.reset_token || "").trim()

if(!resetToken){
showAlert("error","This password reset link is invalid or has expired. Please request a new one.")
setLoading(false)
return
}

navigate(`/reset-password?token=${encodeURIComponent(resetToken)}`,{
state:{email,reset_token:resetToken}
})
},1500)

}catch(error){

showAlert("error","Unable to verify OTP")

}

setLoading(false)

}




const resendOTP = async () => {

try{

const res = await fetch(`${API.BASE_URL}/api/otp/forgot-password/send-otp`,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({email})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message)

}else{

showAlert("success","OTP sent again to your email")

}

}catch(error){

showAlert("error","Unable to resend OTP")

}

}


return(

<Box
sx={{
minHeight:"50vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card sx={{p:4,borderRadius:1,width:"100%",maxWidth:500}}>

<Typography
variant="h5"
sx={{color:Colors.accent}}
fontWeight={700}
>
Verify OTP
</Typography>

{alert.show && (
<Alert severity={alert.type} sx={{mt:2}}>
{alert.message}
</Alert>
)}

<TextField
label="Email Address"
fullWidth
sx={inputStyle}
value={email}
disabled
/>

<TextField
label="Enter OTP"
fullWidth
sx={inputStyle}
value={otp}
onChange={(e)=>setOtp(e.target.value)}
/>

<Button
fullWidth
variant="contained"
sx={{mt:3,backgroundColor:Colors.secondary,color:"white"}}
onClick={verifyOTP}
disabled={otp.length < 4 || loading}
>

{loading
? <CircularProgress size={24} sx={{color:"white"}}/>
: "Verify OTP"
}

</Button>

<Typography
sx={{
mt:2,
textAlign:"center",
fontSize:14,
color:Colors.muted
}}
>

Did not receive OTP?{" "}
<span
style={{
color:Colors.accent,
cursor:"pointer",
fontWeight:600
}}
onClick={resendOTP}
>
Resend OTP
</span>

</Typography>

</Card>

</Box>

)

}


const inputStyle={
mt:2,
"& .MuiOutlinedInput-root":{
"& fieldset":{borderColor:Colors.accent},
"&:hover fieldset":{borderColor:Colors.accent},
"&.Mui-focused fieldset":{borderColor:Colors.accent}
},
"& .MuiInputLabel-root":{
color:Colors.accent
},
"& .MuiInputLabel-root.Mui-focused":{
color:Colors.accent
},
input:{
color:"whitesmoke"
}
}

export default VerifyOTP
